// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"b67d86fe","453":"be6b7493"}[chunkId] + ".chunk.js";
};